const regions = [
  {
    id: 1,
    country: "Asia",
    addressLines: ["No 60 Paya Lebar Road", "#11-06 Paya Lebar Square", "Singapore 409051"],
    tel: "Tel:+65631381767",
  },
  {
    id: 2,
    country: "Middle East",
    addressLines: ["The Onyx Tower 1", "Office 910", "P.O.BOx 410870.", "Dubai,United Arab Emirates"],
    tel: "Tel: +971 4399 52 53",
  },
  {
    id: 3,
    country: "United Sates",
    addressLines: ["2700 POst Oak Blvd", "21st Floor", "Houston,TX 77056"],
    tel: "Tel:+1(800)9478211",
  },
  {
    id: 4,
    country: "Europe",
    addressLines: ["Taubstummengasse", "7A-1040 Vienna"],
    tel: "Tel:+4317866318",
  },
];

const innovationCenters = [
  {
    id: 1,
    country: "Malaysia",
    addressLines: ["Unit 27-13, Level 27, Q Sentral,", "Jalan Stesen Sentral 2,", "50470, Kuala Lumpur,", "Malaysia"],
    tel: "Tel:+60322760055",
  },
  {
    id: 2,
    country: "India",
    addressLines: [
      "13th Cross,Sampige Road",
      "4th Floor,#218 JP Royale,",
      "Malleshwaram,Bengaluru",
      "Karnataka 560003",
    ],
    tel: "Tel:91 807 127 9515",
  },
];

const solutions = [
  {
    id: 1,
    title: "solusi",
    contents: [
      {
        text: "everyday performance",
        link: "https://entomo.co/id/solutions/everyday-performance/",
      },
      {
        text: "first safety",
        link: "https://entomo.co/id/solutions/workplace-safety/",
      },
      {
        text: "everyday insights",
        link: "https://entomo.co/id/solutions/everyday-insights/",
      },
      {
        text: "carrers tomorrow",
        link: "https://entomo.co/id/solutions/careers-tomorrow/",
      },
    ],
  },
  {
    id: 2,
    title: "entomo",
    contents: [
      {
        text: "platform",
        link: "https://entomo.co/id/all-products/entomo/",
      },
      {
        text: "fitur",
        link: "https://entomo.co/id/all-products/pre-configured-editions/",
      },
    ],
  },
];

const inspirations = [
  {
    id: 1,
    title: "inspirasi",
    contents: [
      {
        text: "blogs",
        link: "https://entomo.co/id/resources/blog/",
      },
      {
        text: "peristiwa & webinar",
        link: "https://entomo.co/id/resources/events-webinar/",
      },
      {
        text: "kisah sukses",
        link: "https://entomo.co/id/resources/success-stories/",
      },
      {
        text: "berita & siaran pers",
        link: "https://entomo.co/id/news-press-releases//",
      },
      {
        text: "e buku & laporan resmi",
        link: "https://entomo.co/id/resources/whitepaper-e-book/",
      },
    ],
  },
  {
    id: 2,
    contents: [
      {
        text: "mengapa entomo",
        link: "https://entomo.co/id/about/why-entomo/",
      },
      {
        text: "tim kami",
        link: "https://entomo.co/id/about/our-team/",
      },
      {
        text: "hubungi kami",
        link: "https://entomo.co/id/contact/",
      },
      {
        text: "ajukan demo",
        link: "https://entomo.co/id/request-demo/",
      },
    ],
  },
];

export { regions, innovationCenters, solutions, inspirations };
